export const BRAND = {
  name: "Train With Tristian",
  coach: "Coach Tristian",
  email: "Trainwithtristian@gmail.com",
  location: "Anytime Fitness — Halifax, Nova Scotia",
  logo:
    "https://customer-assets.emergentagent.com/job_route-momentum/artifacts/3fwbp71p_1000000775.png",
  anytimeLogo:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_route-momentum/artifacts/76esft71_AnytimeFitness_Primary_RGB_K.webp",
};

export const COACH_IMAGES = [
  "https://customer-assets.emergentagent.com/job_route-momentum/artifacts/ml595qeq_PSX_20251126_104102.jpg",
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_route-momentum/artifacts/8i1yzjuv_Screenshot_20260716-103021.png",
];

export const IMAGES = {
  hero:
    "https://customer-assets.emergentagent.com/job_route-momentum/artifacts/l03crlof_IMG-20260410-WA0003.jpg",
  coach:
    "https://customer-assets.emergentagent.com/job_route-momentum/artifacts/ml595qeq_PSX_20251126_104102.jpg",
  gym:
    "https://customer-assets.emergentagent.com/job_route-momentum/artifacts/l03crlof_IMG-20260410-WA0003.jpg",
  nutrition:
    "https://images.unsplash.com/photo-1543352632-5a4b24e4d2a6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxoZWFsdGh5JTIwaG9saXN0aWMlMjBudXRyaXRpb24lMjBtZWFsJTIwcHJlcHxlbnwwfHx8fDE3ODM5OTEyMzJ8MA&ixlib=rb-4.1.0&q=85",
};
